import { request } from "./http";

export interface BackupFile {
  name: string;
  size: number; // bytes
  date: string; // ISO
}

export const listBackups = () =>
  request<{ files: BackupFile[] }>("/backups").then(r => r.files);

export const triggerBackup = () =>
  request<{ ok: boolean; fileName: string }>("/backups/trigger", { method: "POST" });

export const restoreBackup = (fileName: string) =>
  request<{ ok: boolean; counts: Record<string, number> }>("/backups/restore", {
    method: "POST",
    body:   JSON.stringify({ fileName }),
  });

/** @param timestamp Format YYYY-MM-DD_HHmmss extrait du nom du fichier */
export const deleteBackup = (timestamp: string) =>
  request<{ ok: boolean }>(`/backups/${encodeURIComponent(timestamp)}`, { method: "DELETE" });
